import style from './P2PResultSuccessFeedbackScreen.css';
import useTranslation from '../../../localization/i18n.context';
import SuccessRoundImage from '../../../assets/images/success-round.webp';
import FormatterUtils from '../../../utils/formatter.utils';
import SuccessFeedbackScreen from '../../shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import WalletIcon from '../../shared/Icons/WalletIcon';
import WorldIcon from '../../shared/Icons/WorldIcon';
import NavigationUtils from '../../../utils/navigation.utils';

export default function P2PResultSuccessFeedbackScreen({
  className = '',
  amount,
  currency,
  cardToName,
  transactionId,
  createdAt,
}) {
  const { t, getCurrency } = useTranslation();

  const listItems = () => {
    const items = [];

    if (transactionId) {
      items.push({
        icon: <WalletIcon />,
        subtitle: t('Transaction ID #{transactionId}').replace(
          '{transactionId}',
          transactionId,
        ),
      });
    }

    if (createdAt) {
      items.push({
        icon: <WorldIcon />,
        subtitle: createdAt
          ? FormatterUtils.formatDateCustom(createdAt, t)
          : '',
      });
    }

    return items;
  };

  return (
    <SuccessFeedbackScreen
      className={`${className} ${style.container}`}
      image={SuccessRoundImage}
      title={t('Money sent successfully!')}
      text={t('{amount} was sent to {name}')
        .replace(
          '{amount}',
          FormatterUtils.currency(amount, getCurrency(currency)),
        )
        .replace('{name}', cardToName)}
      list={listItems()}
      ctaText={t('See transaction')}
      ctaAction={() => {
        NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true);
      }}
      onCloseClick={() => NavigationUtils.endFlow()}
    />
  );
}
